import { MutableRefObject, useRef, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { ReactState, StateSetter, StateSetterAction } from '../Types/Types'

export type ReactStateRef<T> = [MutableRefObject<T>, StateSetter<T>, T]

export const useStateAsRef = <T extends unknown>(initialState: T | (() => T)): ReactStateRef<T> => {
    const [state, setState]: ReactState<T> = useState<T>(initialState)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    const stateAsRef: MutableRefObject<T> = useRef<T>(state)

    const setStateAsRef: StateSetter<T> = (newState: StateSetterAction<T>): void => {
        if (isMounted.current) {
            setState(newState)
            stateAsRef.current = typeof newState === 'function' ? (newState as () => T)() : newState
        }
    }

    return [stateAsRef, setStateAsRef, state]
}
